<div class="flex-column gap-32">
@if (editedMapLayer) {
  <app-card [inCardTitle]="mapLayerIndex === -1 ? 'Create Map Layer' : 'Editing Map Layer'"
            icon="arrow_back"
            actionIcon="save"
            [iconDisabled]="false"
            (iconClicked)="backToList()"
            (actionIconClicked)="save()"
            [actionIconDisabled]="!mapLayerToSave || !editingStateValid">
    <div *appCardContent>
      <app-map-layer-editor
        [mapLayer]="editedMapLayer"
        (layerChanged)="onLayerEditorChange($event)"
      >
      </app-map-layer-editor>
    </div>
  </app-card>
}

@if (mapLayers && !editedMapLayer) {
  <app-card preCardTitle="Layers Management">
    <div *appCardContent class="settings-header-container justify-content-space-between">
      <div class="settings-header-title">
        <p>Add Custom Layer</p>
        <!--<div class="settings-header-subtitle">xxx</div>-->
      </div>
      <div class="settings-header-actions">
        <button (click)="editNewLayer()"
                mat-stroked-button>
          Add New Layer
        </button>
      </div>
    </div>
  </app-card>

  <app-card preCardTitle="Custom Layers">
    <div *appCardContentRaw>
      <mat-nav-list class="raw-card-list">
        <mat-menu #layerMenu="matMenu">
          <ng-template matMenuContent let-layerIndex="index" let-layer="layer">
            <button mat-menu-item (click)="deleteLayer(layer, layerIndex)">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
            <button mat-menu-item (click)="moveLayerDown(layerIndex)">
              <mat-icon>south</mat-icon>
              <span>Move Layer</span>
            </button>
          </ng-template>
        </mat-menu>

        @for (mapLayer of mapLayers; track mapLayer.id; ) {
          <mat-list-item (click)="editLayer($index)">
            <div matListItemTitle
                 class="flex-row gap-16 align-items-center">
              <div>
                <mat-icon
                  [matTooltip]="mapLayer.type === MapLayerType.VECTOR ? 'Vector Layer' : 'Raster Layer'">
                  @if (mapLayer.type === MapLayerType.VECTOR) {
                    polyline
                  } @else {
                    layers
                  }
                </mat-icon>
              </div>
              <span>{{ mapLayer.name }}</span>
              <small class="text-muted">
                @if (mapLayer.type === MapLayerType.RASTER) {
                  {{ mapLayer.url }}
                } @else if (mapLayer.type === MapLayerType.ROUTE) {
                  System generated layer
                }
              </small>
            </div>
            <div matListItemMeta class="flex-row align-items-center gap-8">
              @if (mapLayer.publicEnabled !== undefined && mapLayer.publicEnabled !== null) {
                <span>(shown on public portal)</span>
              }
              <button mat-icon-button
                      (click)="$event.stopPropagation()"
                      [matMenuTriggerFor]="layerMenu"
                      [matMenuTriggerData]="{index:$index,layer:mapLayer}"
                      aria-label="Menu">
                <mat-icon>more_vert</mat-icon>
              </button>
            </div>
          </mat-list-item>
        }
      </mat-nav-list>
    </div>
  </app-card>

} @else if (!mapLayers) {
  <mat-spinner class="mx-a mt-15" diameter="30"></mat-spinner>
}
</div>
